import { NestedDossierProcessesOpenSearch } from '@europrocurement/l2d-domain';
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { FieldValues, useForm } from 'react-hook-form';
import { OptionsType } from '@europrocurement/flexy-components';
import { DossierValidatorStatus } from '@europrocurement/l2d-modules';
import { enqueueSnackbar } from 'notistack';
import { useDossierProcesses } from '../../hooks';

type UpdateValideurFormProps = {
    processing: boolean;
    onItemSelected: () => void;
    process: NestedDossierProcessesOpenSearch;
    statuses: Array<DossierValidatorStatus>;
};

const UpdateValidatorForm: React.FunctionComponent<UpdateValideurFormProps> = function ({
    processing,
    onItemSelected,
    process,
    statuses,
}) {
    const { updateValidatorProcess } = useDossierProcesses();
    const [typeStatus, setTypeStatus] = useState<OptionsType>([]);
    const currentStatus = { value: process?.statusCode || '', label: process?.statusLabel || '' };

    useEffect(() => {
        setTypeStatus(
            statuses
                .sort((a, b) => (a.sortOrder as number) - (b.sortOrder as number))
                .map((status) => ({
                    value: status.code,
                    label: status.label as unknown as string,
                })),
        );
    }, [statuses]);

    const formContext = useForm<FieldValues>({
        mode: 'onChange',
        defaultValues: {
            statusCode: currentStatus,
        },
    });

    const selectedStatus = formContext.watch('statusCode');

    const handleFormSubmit = async (value: string) => {
        if (value) {
            try {
                await updateValidatorProcess(process.id as number, value);
                onItemSelected();
            } catch (e) {
                console.error(e);
                enqueueSnackbar(
                    'Une erreur est survenue lors du changement de statut de votre démarche',
                    { variant: 'error' },
                );
            }
        }
    };

    // Catch select onChange
    useEffect(() => {
        if (!processing && selectedStatus && selectedStatus.value !== currentStatus.value) {
            handleFormSubmit(selectedStatus.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedStatus, currentStatus]);

    const formProps = {
        formContext,
        onSubmit: () => {},
        submitButton: {
            displayed: false,
        },
    };

    const formStructure: FormStructure[] = [
        {
            type: 'select',
            name: 'statusCode',
            inputlabel: 'Statut',
            options: typeStatus,
            getOptionLabel: ({ label }: { label: string }) => label,
            getOptionValue: ({ value }: { value: string }) => value,
            xs: 12,
        },
    ];

    return (
        <Box sx={{ minWidth: '500px' }}>
            <Typography variant="l2dh6">Modifier le statut</Typography>
            <Box
                sx={{
                    padding: '26px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '10px',
                }}
            >
                <FlexyForm
                    formStructure={formStructure}
                    {...formProps}
                />
            </Box>
        </Box>
    );
};

export default UpdateValidatorForm;
